/**
 * Counts how many characters are needed for show a number by a given accuracy.
 * 10->0,
 * 5.1234->4
 * 1->0,
 * 0.5->1,
 * 0.1234->4,
 * 0.1->1,
 * 0.05->2,
 * 0.01->2
 * 0.012->3
 * ...
 * @param {number} accuracy
 * @return {number}
 */
 function getFractionLengthByAccuracy(accuracy) {
    const str = accuracy.toString();
    let decimalPointPos = str.indexOf('.');
    if (decimalPointPos === -1) {
        return 0;
    } else {
        const fractionPart = str.substr(decimalPointPos + 1);
        let zerosCount = 0;
        for(let char of fractionPart) {
            if (char !== '0') {
                break;
            }
            zerosCount++;
        }
        return zerosCount + 1;
    }
}

/**
 * Represent the given number by a given accuracy.
 * @param {number} number Number to convert
 * @param {number} accuracy Smallest step that has to be able to represented by the converted value.
 * @return {string} The converted number as string. (Padded by zeros according to accuracy)
 */
export function formatAccuracy (number, acc = 1) {
    if (isNaN(number) || number === null || typeof number === 'boolean') return number;

    let accuracy = acc || 1;
    // `x * (1/accuracy)` instead of using `x / accuracy`
    // helped resolving some flotaing point anomaly when accuracy was 0.01
    const converted =  Math.round(number * (1 / accuracy)) / (1 / accuracy);
    let int = converted.toString();
    let fract = '';
    const decimalPointPos = converted.toString().indexOf('.');
    if (decimalPointPos !== -1) {
        int = int.substr(0, decimalPointPos);
        const fractionLength = getFractionLengthByAccuracy(accuracy);
        fract = converted.toString().substr(decimalPointPos + 1).padEnd(fractionLength, '0');
    }
    
    return int + (fract === '' ? '' : '.' + fract);
}
